<template>
  <tr>
    <td>{{ occupation.name }}</td>
    <td class="p-t-5 p-b-5 v-align-middle">
      <div class="btn-toolbar flex-wrap">
        <div class="btn-group">
          <slide-toggle
            v-model="occupation.active"
            :canEdit="true"
            :stringValues="{ on: true, off: false }"
            @input="toggleActiver"
          ></slide-toggle>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import { mapActions } from 'vuex'
  import SlideToggle from '@/components/pages/SlideToggle'

  export default {
    props: ['occupation', 'currentEntity'],
    components: {
      SlideToggle,
    },
    methods: {
      ...mapActions({
        changeActiveStatus: 'occupations/changeActiveStatus',
        getDeactivatePermission: 'occupations/getDeactivateOccupationPermission',
        loadList: 'occupations/loadList'
      }),

      toggleActiver(value) {
        if(!value) {
          this.deactivateOccupation()
        } else {
          this.activateOccupation()
        }
      },

      activateOccupation() {
        this.changeActiveStatus({ ...this.occupation, entity_id: this.currentEntity.id })
      },

      deactivateOccupation() {
        this.getDeactivatePermission({ ...this.occupation, entity_id: this.currentEntity.id }).then((response) => {
          if (response.status == 200 && response.data.can_deactivate) {
            this.changeActiveStatus({ ...this.occupation, entity_id: this.currentEntity.id })
          } else if (response.data.type == 'user') {
            this.loadList(this.currentEntity.id)
            this.$dialog.alert(this.$i18n.t('Occupations.messages.deactivate_occupation_relates_users'))
          } else {
            this.loadList(this.currentEntity.id)
            this.$dialog.alert(this.$i18n.t('Occupations.messages.deactivate_occupation_has_active_offers'))
          }
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/occupations/OccupationGroup.vue